import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { WPQTTooltip } from "../Tooltip/WPQTTooltip";
function WPQTDropdown({ children, menuBtn, menuBtnClasses = "", anchor = "bottom end", }) {
    return (_jsxs(Menu, { children: [_jsx(MenuButton, { as: "div", className: `wpqt-cursor-pointer ${menuBtnClasses}`, onClick: (event) => event.stopPropagation(), children: ({ active }) => _jsx(_Fragment, { children: menuBtn({ active }) }) }), _jsx(MenuItems, { anchor: anchor, transition: true, className: "wpqt-z-20 wpqt-origin-top wpqt-rounded-xl wpqt-border wpqt-border-solid wpqt-border-qtBorder wpqt-bg-white wpqt-p-4 wpqt-transition wpqt-duration-200 wpqt-ease-out data-[closed]:wpqt-scale-95 data-[closed]:wpqt-opacity-0", children: children })] }));
}
function WPQTDropdownIcon({ isActive, IconComponent }) {
    return (_jsx(IconComponent, { className: `wpqt-size-6 wpqt-text-gray-400 hover:wpqt-text-qtBlueHover ${isActive ? "wpqt-text-qtBlueHover" : ""}` }));
}
function WPQTDropdownItem({ text, onClick, icon, className, disabled = false, id = "", tooltipText = "", }) {
    const showTooltip = tooltipText !== "" && id !== "";
    const tooltipAttributes = showTooltip
        ? {
            "data-tooltip-id": id,
            "data-tooltip-content": tooltipText,
            "data-tooltip-position-strategy": "fixed",
            "data-tooltip-variant": "info",
        }
        : {};
    return (_jsx(MenuItem, { children: _jsxs("div", Object.assign({}, tooltipAttributes, { className: `${className} wpqt-mb-3 wpqt-flex wpqt-items-center wpqt-gap-2 ${!disabled
                ? "wpqt-cursor-pointer hover:wpqt-underline"
                : "wpqt-cursor-not-allowed wpqt-line-through"}`, onClick: (e) => {
                if (!disabled && onClick) {
                    onClick(e);
                }
            }, children: [icon, text, _jsx(WPQTTooltip, { id: id })] })) }));
}
export { WPQTDropdown, WPQTDropdownIcon, WPQTDropdownItem };
